<template>
  <el-card class="card-main">
    <div slot="header" class="clearfix">
      <el-radio-group v-model="activeName" @change="handleClick" class="radioGroup">
        <el-radio-button label="plan">喷灌计划</el-radio-button>
        <el-radio-button label="record">喷灌记录</el-radio-button>
        <el-radio-button label="manage">灌区管理</el-radio-button>
      </el-radio-group>
    </div>
    <router-view />
  </el-card>
</template>

<script>

export default {
  name: 'IrrigationDetail',
  data () {
    return {
      activeName: 'plan'
    }
  },

  created () {
    // this.$store.dispatch('getCarTypeList')
    this.setActive()
  },
  methods: {

    setActive () {
      const url = this.$route.path
      const start = url.lastIndexOf('/')
      this.activeName = url.substring(start + 1)
    },

    handleClick () {
      this.$router.replace({ path: '/irrigation2/detail/' + this.activeName, query: { projectId: this.$route.query.projectId } })
    }
  }

}
</script>

<style scoped lang="scss">
.card-main {
  height: calc(100% - 40px);
}

.radioGroup {
  padding-top: 20px;
  padding-left: 20px;
}

::v-deep .el-card__body {
  height: calc(100% - 100px);
}

::v-deep .el-card__header {
  padding: 0;
}
</style>
